import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { CompassProvider, useCompass } from "../../contexts/CompassContext";
import GridOverlay from "../GridOverlay";

import CompassSidePanel from "./CompassSidePanel";

function getShowCompassPanel(pathname: string): boolean {
  return (
    pathname === "/rl/template" ||
    pathname === "/rl/pdp" ||
    pathname === "/ji/compass-prototype" ||
    pathname.startsWith("/rl/compass-contained/")
  );
}

function getShowCompassDrawer(pathname: string): boolean {
  return (
    pathname === "/rl/pdp-with-drawer" ||
    pathname === "/rl/pdp-with-drawer-left" ||
    pathname === "/rl/pdp-v2-with-ai" ||
    pathname.startsWith("/rl/pdp/snacks/")
  );
}

function CompassLayoutInner({ children }: { children: ReactNode }) {
  const { state: compassState } = useCompass();
  const location = useLocation();

  const showCompassDrawer = getShowCompassDrawer(location.pathname);
  const showCompassSidePanel =
    getShowCompassPanel(location.pathname) && !showCompassDrawer;
  const shouldApplyMargin = showCompassSidePanel && compassState.isPanelOpen;

  return (
    <>
      {showCompassSidePanel && <CompassSidePanel />}
      <div
        style={{
          marginRight: shouldApplyMargin ? "385px" : "0",
          transition: "margin-right 350ms cubic-bezier(0.4, 0, 0.2, 1)",
        }}
      >
        {children}
      </div>
    </>
  );
}

export function CompassLayout({ children }: { children: ReactNode }) {
  return (
    <CompassProvider>
      <GridOverlay />
      <CompassLayoutInner>{children}</CompassLayoutInner>
    </CompassProvider>
  );
}
